export const jsMessageType = Object.freeze({
    LOGIN: 'LOGIN_PHONE',
    LOGOUT: 'LOGOUT',
    HRT_BEAT: 'HRT_BEAT',
    LOGIN_RESPONSE: 'LOGIN_RESPONSE',
    LOGIN_RESPONSE_AGENT: 'LOGIN_RESPONSE_AGENT',
    REQUEST_SETTINGS: 'REQUEST_SETTINGS',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    AGENT_STATE: 'AGENT_STATE',
    SET_AUTOANSWER: 'SET_AUTOANSWER',
    SET_AVAILABILITY: 'SET_AVAILABILITY',
    SET_RAISEHAND: 'SET_RAISEHAND',
    INVALID_PARAM: 'INVALID_PARAM',
    INVALID_AGENT: 'INVALID_AGENT',
    AGENT_ROUTING_STATU: 'AGENT_ROUTING_STATUS',
    GROUP_CALL_RINGING: 'GROUP_CALL_RINGING',
    GROUP_CALL_CONNECTED: 'GROUP_CALL_CONNECTED',
    SET_LOGIN: 'SET_LOGIN',
    FORCED_LOGOUT: 'FORCED_LOGOUT',
    GROUP_CALL_DISCONNECTED: 'GROUP_CALL_DISCONNECTED',
    END_WRAPUPTIME: 'END_WRAPUPTIME',
    SET_WRAPUPTIME: 'SET_WRAPUPTIME',
    AGENTSTATUS_LIST: 'AGENTSTATUS_LIST',
    ABSENCE_LIST: 'ABSENCE_LIST',
    QUEUE_CHANGE: 'QUEUE_CHANGE',
    AGENT_CHANGE: 'AGENT_CHANGE',
    INVALID_OPERATION: 'INVALID_OPERATION',
    SET_OUTCOME: 'SET_OUTCOME',
    SET_OUTCOME_RESPONSE: 'SET_OUTCOME_RESPONSE',
    SET_AGENT_QUEUES_AVAILABILITY: 'SET_AGENT_QUEUES_AVAILABILITY',
    QUEUESTATUS_LIST: 'QUEUESTATUS_LIST',
    VBOARD_STATS_CHANGED: 'VBOARD_STATS_CHANGED',

})

export const agentStatuses = Object.freeze({
    Offline: 0,
    Available : 1,
    Clerical_Work : 2,
    Temp_Absent : 3,
    Not_Answered : 4,
    Ringing_IN_ACD : 5,
    ACD_Busy : 6,
    Idle : 7,
    Non_Acd_Busy : 8,
    Being_Routed : 9,
    Faulty : 10,       
    Busy_OutgoingDialing : 11,
    Not_Available : 12,
    Busy_OutboundCall : 13,
    Non_Acd_Ringing : 14,
    Acd_OnHold : 15,
    Non_Acd_OnHold : 16,
    Ringing_IN_ACD_Callback : 17,
    ACD_Busy_Callback : 18,
    Acd_OnHold_Callback : 19,
    ACD_Login : 20,
    None :49,
    Custom_Transfer_ACD : 50,
    Custom_Transfer_Other : 51,
    Custom_Call_Hold : 52,
    Custom_Call_UnHold : 53,
    Custom_Call_ReleaseByAgent : 54,
    Custom_Connecting_ACD : 55,
    Custom_Connecting_NonACD:56,
    Custom_HangingUp: 57,
        
})